export const environment = {
  production: false,
  apiUrl: window["env"]["apiUrl"] || "https://api.myapp.local",
  uiUrl: window["env"]["uiUrl"]  || "https://ui.myapp.local",
  idleTimeout: window["env"]["idleTimeout"] || "240",
  idleWarningTimeout: window["idleWarningTimeout"] || "60",
  gitCommitRef: window["env"]["gitCommitRef"] || "local",
  gitCommitId: window["env"]["gitCommitId"] || "0000000",
  gitCommitTimestamp: window["env"]["gitCommitTimestamp"] || "1980-01-01T00:00:00.000Z",
  enableDebug: true,
  stsAuthority: window["env"]["stsAuthority"] || "https://ui.myapp.local",
  clientId: window["env"]["clientId"] || "abcd",
  clientRoot: window["env"]["clientRoot"] || "https://ui.myapp.local",
  clientScope: window["env"]["clientScope"] || "abcd"
};
